import * as React from "react"
import { SpeakerFragment } from "../../generated/apolloComponents";
import { Card, CardBody } from "reactstrap";
import Avatar from "./Avatar";
import Upvote from "../ui/Upvote";

type Props = SpeakerFragment & {
  className?: string,
};

const pages = {
  'Omar Dhalla': 'omar-dhalla',
  'Areeq Chowdhury': 'areeq-chowdhury',
};

const SpeakerCard: React.FunctionComponent<Props> = ({ id, name, bio, resume, image, className }) => (
  <Card className={`border-0 bg-transparent mb-2 ${className}`}>
    <CardBody>
      <div className="row align-items-center">
        <div className="col-sm-12 mb-3 mb-sm-0">
          <div className="d-flex">
            <div>
              <Avatar name={name} image={image ? image.imageCoverPreview: null} />
              <Upvote id={id} gaLabel={name} gaActionSuffix="Speaker" />
            </div>

            <div className="mr-3">
              <div className="mb-2">
                <h3 className="h6 mb-0" style={{fontWeight: 'normal'}}>
                  {name}
                  {bio && <p className="text-muted">{bio}</p>}
                  {resume && <p>{resume}</p>}
                </h3>
                {name in pages && <a href={`/speakers/${pages[name]}`} className="stretched-link btn btn-xs btn-primary">View Profile</a>}
              </div>

            </div>
          </div>
        </div>
      </div>
      {/* <CardTitle>{name}</CardTitle> */}
      {/* <CardSubtitle>{bio}</CardSubtitle> */}
      {/* <CardText>{resume}</CardText> */}
    </CardBody>
  </Card>
)

export default SpeakerCard
